import { reduce } from 'lodash';
import { Logger } from './logger';
// Deprecated: we'll ask by string from now own to be more flexible
export var EnvVars;
(function (EnvVars) {
    EnvVars["ALLOW_USERPASS_LOGIN"] = "ALLOW_USERPASS_LOGIN";
    EnvVars["ANALYTICS_AMPLITUDE_KEY"] = "ANALYTICS_AMPLITUDE_KEY";
    EnvVars["API_ENDPOINT"] = "API_ENDPOINT";
    EnvVars["API_MODE"] = "API_MODE";
    EnvVars["APP_KEY_PREFIX"] = "APP_KEY_PREFIX";
    EnvVars["AUTH0_CLIENTID"] = "AUTH0_CLIENTID";
    EnvVars["AUTH0_DOMAIN"] = "AUTH0_DOMAIN";
    EnvVars["BASE_URL"] = "BASE_URL";
    EnvVars["CERES_API_ENDPOINT"] = "CERES_API_ENDPOINT";
    EnvVars["IA_APP_KEY_PREFIX"] = "IA_APP_KEY_PREFIX";
    EnvVars["IA_ENV"] = "IA_ENV";
    EnvVars["LOGGING_SENTRY_KEY"] = "LOGGING_SENTRY_KEY";
    EnvVars["NODE_ENV"] = "NODE_ENV";
    EnvVars["PUBLIC_URL"] = "PUBLIC_URL";
    EnvVars["SMARTY_STREETS_KEY"] = "SMARTY_STREETS_KEY";
    EnvVars["LOCIZE_PROJECT_KEY"] = "LOCIZE_PROJECT_KEY";
})(EnvVars || (EnvVars = {}));
// tslint:disable-next-line:no-any
var windowConfig = window.config;
var storedConfig = {};
if (windowConfig) {
    storedConfig = windowConfig;
}
else {
    Logger.error('Could not find `config` object on window.  Make sure this file gets created as part of build');
}
var appPrefix = storedConfig[EnvVars.IA_APP_KEY_PREFIX] || '';
// Make sure prefix does not end in underscore so that keys are formatted correctly
var APP_KEY_PREFIX = appPrefix && appPrefix.charAt(appPrefix.length - 1) === '_'
    ? appPrefix.substring(0, appPrefix.length - 1)
    : appPrefix;
var GLOBAL_PREFIX = 'IA_GLOBAL';
var keys = reduce(EnvVars, function (total, envKey) {
    // Use a waterfall to find environment variables.
    // 1. App prefixed: IA_INSIGHTS_API_ENDPOINT, else
    // 2. Global prefixed: IA_GLOBAL_API_ENDPOINT, else
    // 3. Not prefixed: API_ENDPOINT
    total[envKey] =
        storedConfig[APP_KEY_PREFIX + "_" + envKey] ||
            storedConfig[GLOBAL_PREFIX + "_" + envKey] ||
            storedConfig[envKey] ||
            '';
    return total;
}, {});
// Instead of having to explicitly define each of the environment variables we could have in our apps
// we should instead just allow access to all items in the config object as each project will be in
// control of what ends up in there.
var getConfig = function (key) {
    var value = storedConfig[APP_KEY_PREFIX + "_" + key] || storedConfig[key] || '';
    if (!value) {
        Logger.error("Cannot find config key: " + key);
    }
    return value;
};
// Gets the window (or self if we're running in a webworker etc) or throws if it cannot be found.
var hostName = function () {
    var win = null;
    if (typeof self !== 'undefined') {
        win = self;
    }
    if (typeof window !== 'undefined') {
        win = window;
    }
    if (!win) {
        return null;
    }
    else {
        return win.location.hostname;
    }
};
var isLocalEnvironment = hostName() === 'localhost';
export var get = function (key) { return (key ? keys[key] || getConfig(key) : ''); };
export var isDevelopment = get(EnvVars.NODE_ENV) === 'development' || isLocalEnvironment;
export var isStaging = get(EnvVars.NODE_ENV) === 'staging' && !isLocalEnvironment;
export var isProd = get(EnvVars.NODE_ENV) === 'production' && !isLocalEnvironment;
export var isTest = get(EnvVars.NODE_ENV) === 'test' && !isLocalEnvironment;
export var isDemo = get(EnvVars.NODE_ENV) === 'demo' && !isLocalEnvironment;
//# sourceMappingURL=config.js.map